const baseTheme = {
  FONT_BASE: '"Inter", sans-serif',
  BLACK: "#000000",
  WHITE: "#ffffff",
  BORDER_COLOR: "#4E4E4E",
};

const themes = {
  data2go: {
    PRIMARY: "#1F122F",
    ACCENT: "#6A459A",
    MAIN_BG: "#0E0020",
    SECONDARY_BG: "#1F122F",
    BTN_BG: "#493A5D",
    ICON_BG: "#301E4C",
  },
  'data2go-corporate': {
    PRIMARY: "#1F122F",
    ACCENT: "#6A459A",
    MAIN_BG: "#0E0020",
    SECONDARY_BG: "#1F122F",
    BTN_BG: "#493A5D",
    ICON_BG: "#301E4C",
  },
  esimcrew: {
    PRIMARY: "#ff1d00",
    ACCENT: "#0075ff",
    MAIN_BG: "#140e1c",
    SECONDARY_BG: "#1E1E1E",
    BTN_BG: "#3a3b3c",
    ICON_BG: "#140e1c",
  },
  esimlinks: {
    PRIMARY: "#000000",
    ACCENT: "#f05123",
    MAIN_BG: "#121212",
    SECONDARY_BG: "#1E1E1E",
    BTN_BG: "#333333",
    ICON_BG: "#140e1c",
  },
  gopamwe: {
    PRIMARY: "#171760",
    ACCENT: "#171760",
    MAIN_BG: "#171760",
    SECONDARY_BG: "#171760",
    BTN_BG: "#171760",
    ICON_BG: "#140e1c",
  },
   "gopamwe-corporate": {
    PRIMARY: "#171760",
    ACCENT: "#171760",
    MAIN_BG: "#171760",
    SECONDARY_BG: "#171760",
    BTN_BG: "#171760",
    ICON_BG: "#140e1c",
  },
  pinoy: {
    PRIMARY: "#1d1d1d",
    ACCENT: "#1d1d1d",
    MAIN_BG: "#1d1d1d",
    SECONDARY_BG: "#1d1d1d",
    BTN_BG: "#1d1d1d",
    ICON_BG: "#140e1c",
  },
   "pinoy-corporate": {
    PRIMARY: "#1d1d1d",
    ACCENT: "#1d1d1d",
    MAIN_BG: "#1d1d1d",
    SECONDARY_BG: "#1d1d1d",
    BTN_BG: "#1d1d1d",
    ICON_BG: "#140e1c",
  },

    orzo: {
    PRIMARY: "#224046",
    ACCENT: "#224046",
    MAIN_BG: "#224046",
    SECONDARY_BG: "#224046",
    BTN_BG: "#224046",
    ICON_BG: "#224046",
  },
   "orzo-corporate": {
    PRIMARY: "#224046",
    ACCENT: "#224046",
    MAIN_BG: "#224046",
    SECONDARY_BG: "#224046",
    BTN_BG: "#224046",
    ICON_BG: "#140e1c",
  },

  awesim: {
    PRIMARY: "#585858",
    ACCENT: "#6d88ff",
    MAIN_BG: "#585858",
    SECONDARY_BG: "#1E1E1E",
    BTN_BG: "#585858",
    ICON_BG: "#140e1c",
  },
  esimple: {
    PRIMARY: "#db5a03",
    ACCENT: "#0050af",
    MAIN_BG: "#00224a",
    SECONDARY_BG: "#1E1E1E",
    BTN_BG: "#00224a",
    ICON_BG: "#140e1c",
  },
};

const defaultTheme = themes["data2go"];

const getThemeColors = () => {
  const appName = process.env.REACT_APP_NAME || "data2go";
  const selectedTheme = themes[appName] || defaultTheme;
  return {
    ...baseTheme,
    ...selectedTheme,
  };
};

export default getThemeColors;